import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/vote"
    },
    {
      path: '/vote',
      name: 'vote',
      component: () => import('./views/Vote.vue')
    },
    {
      path: '/rank',
      name: 'rank',
      component: () => import('./views/Rank.vue')
    },
    {
      path: '/desc',
      name: 'desc',
      component: () => import('./views/Desc.vue')
    },
  ],
})

// const routes = [
//   {
//     path: "*",
//     redirect: "/vote"
//   },
//   {
//     path: '/vote',
//     name: 'vote',
//     component: () => import('./views/Vote.vue')
//   },
//   {
//     path: '/rank',
//     name: 'rank',
//     component: () => import('./views/Rank.vue')
//   },
//   {
//     path: '/desc',
//     name: 'desc',
//     component: () => import('./views/Desc.vue')
//   },
//   {
//     path: '/vote-detail',
//     name: 'vote-detail',
//     component: () => import('./views/VoteDetail.vue')
//   },
// ]
// console.log(process.env.BASE_URL)
// const router = new Router({ base: process.env.BASE_URL, routes: routes });

// router.beforeEach((to, from, next) => {
//   // const title = to.meta && to.meta.title;
//   // if (title) {
//   //   document.title = title;
//   // }
//   // next();
// });

// export default router;